module.exports = __webpack_public_path__ + "img/progress.d2a19e7b.svg";